<template>
  <div>
    <sub-content-container :title="$t('myInterests.arts.title')">
      <interest :interests="completeInterests" />
    </sub-content-container>
  </div>
</template>

<script>
const SubContentContainer = () =>
  import(
    /* webpackChunkName: "SubContentContainerComponent" */ "@/components/Global/SubContentContainer.vue"
  );
const Interest = () =>
  import(/* webpackChunkName: "MyInterestsPage" */ "@/components/MyInterests/Interest.vue");

export default {
  name: "Arts",
  components: {
    SubContentContainer,
    Interest
  },
  data() {
    return {
      title: "Mis intereses sobre las artes",
      interests: [
        {
          icon: ["fas", "guitar"],
          backgroundColor: "black"
        },
        {
          icon: ["fas", "music"]
        },
        {
          icon: ["fas", "camera-retro"],
          backgroundColor: "black"
        },
        {
          icon: ["fas", "video"]
        }
      ]
    };
  },
  computed: {
    completeInterests() {
      return this.interests.map((data, i) => ({
        ...data,
        ...this.$t("myInterests.arts.interests")[i]
      }));
    }
  }
};
</script>
